import { TASK_STATUS_STYLES } from "../constants";
import type { SocialPostGenerationStatus } from "../types";
import { StatusPill } from "@/components/common/status-pill";

export function TaskStatusBadge({ status }: { status: SocialPostGenerationStatus }) {
  return <StatusPill label={status} className={TASK_STATUS_STYLES[status]} />;
}
